import { render } from "./CategoryArea.vue?vue&type=template&id=f7b2cdc4"
import script from "./CategoryArea.vue?vue&type=script&lang=js"
export * from "./CategoryArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__